import { useEffect, useRef, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const Arrow = (props: any) => (
    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.33203 0.999939L9.33203 8.99994L1.33203 16.9999" stroke="#707070" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

interface SwiperTabsProps {
    value: number;
    tabs: { label: string; value: number }[];
    onChange?: (index: number) => void;
    contentRef: React.RefObject<HTMLDivElement>;
}
function SwiperTabs({ onChange, value, tabs, contentRef }: SwiperTabsProps) {
    const prevButton = useRef<HTMLDivElement>(null);
    const nextButton = useRef<HTMLDivElement>(null);
    const [showNavigation, setoShowNavigation] = useState(false);
    const [swiperGap, setSwiperGap] = useState(24);
    const [isWeb, setIsWeb] = useState(true);

    const filterRef = useRef<HTMLDivElement>(null);
    const handlerClick = (e: any, idx: number) => {
        const tabItem = e.target as HTMLElement;
        if (filterRef.current && tabItem.id === `FAQ-item-${idx}`) {
            const centerNum = tabItem.offsetLeft - filterRef.current.offsetWidth / 2 + tabItem.offsetWidth / 2;
            filterRef.current.scrollTo({ left: centerNum, behavior: 'smooth' });
        }
        onChange?.(idx);
    };

    const swiperRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const callback = () => {
            if (!contentRef.current || !swiperRef.current) return;
            if (swiperRef.current.offsetWidth === contentRef.current.offsetWidth) {
                setoShowNavigation(true);
            } else {
                setoShowNavigation(false);
            }
            if (window.innerWidth > 1024) {
                setSwiperGap(30);
                setIsWeb(true);
            } else {
                setIsWeb(false);
                setSwiperGap(32);
            }
        };
        setTimeout(() => {
            callback();
        }, 100);
        // 监听窗口尺寸变化
        window.addEventListener('resize', callback);
        return () => window.removeEventListener('resize', callback);
    }, [contentRef]);

    return (
        <div className="temp-member-FAQ-filter-content">
            <div style={{ width: 'fit-content', maxWidth: '100%', '--swiper-tabs-gap': `${swiperGap}px` }} ref={swiperRef}>
                <div
                    className="temp-member-FAQ-filter-btn temp-member-FAQ-filter-btn-left"
                    style={{ display: 'none', opacity: showNavigation && isWeb ? 1 : 0, pointerEvents: showNavigation && isWeb ? 'all' : 'none' }}
                    ref={prevButton}
                >
                    <Arrow style={{ transform: 'scaleX(-1)' }} />
                </div>
                <div
                    className="temp-member-FAQ-filter-btn temp-member-FAQ-filter-btn-right"
                    style={{ opacity: showNavigation && isWeb ? 1 : 0, pointerEvents: showNavigation && isWeb ? 'all' : 'none' }}
                    ref={nextButton}
                >
                    <Arrow />
                </div>
                <Swiper
                    className="temp-member-FAQ-filter"
                    spaceBetween={swiperGap}
                    modules={[Navigation]}
                    navigation={{
                        prevEl: prevButton.current, // 指定上一个按钮的选择器
                        nextEl: nextButton.current, // 指定下一个按钮的选择器
                    }}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    slidesPerGroup={2}
                    onTransitionEnd={(swiper) => {
                        console.log('动画结束');
                        if (!prevButton.current || !nextButton.current) return;
                        // 检查是否在第一个滑块
                        if (swiper.isBeginning) {
                            prevButton.current.style.display = 'none';
                        } else {
                            prevButton.current.style.display = 'flex';
                        }
                        // 检查是否在最后一个滑块
                        if (swiper.isEnd) {
                            nextButton.current.style.display = 'none';
                        } else {
                            nextButton.current.style.display = 'flex';
                        }
                    }}
                >
                    {tabs.map((i, idx) => (
                        <SwiperSlide
                            className={`temp-member-FAQ-filter-item ${idx === value ? 'active' : ''}`}
                            onClick={(e) => handlerClick(e, idx)}
                            id={`FAQ-item-${idx}`}
                            style={{ width: 'fit-content' }}
                            key={idx}
                        >
                            {i.label}
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}

export default SwiperTabs;
